import { put, call, takeLatest } from "redux-saga/effects";
import axiosInstance from "../../utils/AxiosConfig";
import {
  getallorderRequest,
  getallorderSuccess,
  getallorderFailure,
  getwishlistRequest,
  getwishlistSuccess,
  getwishlistFailure,
  addAddressRequest,
  addAddressSuccess,
  addAddressFailure,
  getaddressRequest,
  getaddressSuccess,
  getaddressFailure,
  insertprofileRequest,
  insertprofileSuccess,
  insertprofileFailure,
  getprofileRequest,
  getprofileSuccess,
  getprofileFailure,
} from "./Account-slice";

function* getallordersaga(action) {
  try {
    const response = yield axiosInstance.get(`orders/my-orders`, {
      params: action.payload,
    });
    yield put(getallorderSuccess(response.data));
  } catch (error) {
    yield put(getallorderFailure(error.message));
  }
}

export function* watchgetallordersaga() {
  yield takeLatest(getallorderRequest.type, getallordersaga);
}

function* getwishlistSaga(action) {
  try {
    const response = yield axiosInstance.get(`getWishlist`, {
      params: action.payload,
    });
    yield put(getwishlistSuccess(response.data));
  } catch (error) {
    yield put(getwishlistFailure(error.message));
  }
}

export function* watchgetwishlistSaga() {
  yield takeLatest(getwishlistRequest.type, getwishlistSaga);
}

function* addAddressSaga(action) {
  // for (let [key, value] of action.payload.entries()) {
  //   console.log(key, value);
  // }
  try {
    const response = yield axiosInstance.post(
      `saveProfile`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    yield put(addAddressSuccess(response.data));
  } catch (error) {
    yield put(addAddressFailure(error.response?.data?.message || error.message));
  }
}

export function* watchaddAddress() {
  yield takeLatest(addAddressRequest.type, addAddressSaga);
}

function* getaddressSaga(action) {
  try {
    const response = yield axiosInstance.get(`getProfile`, {
      params: action.payload,
    });
    yield put(getaddressSuccess(response.data));
  } catch (error) {
    yield put(getaddressFailure(error.message));
  }
}

export function* watchgetaddressSaga() {
  yield takeLatest(getaddressRequest.type, getaddressSaga);
}

function* getprofileSaga(action) {
  try {
    const response = yield axiosInstance.get(`getProfile`, {
      params: action.payload,
    });
    yield put(getprofileSuccess(response.data));
  } catch (error) {
    yield put(getprofileFailure(error.message));
  }
}

export function* watchgetprofileSaga() {
  yield takeLatest(getprofileRequest.type, getprofileSaga);
}
function* insertprofileSaga(action) {
  try {
    const response = yield axiosInstance.post(`profiledata`, action.payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    yield put(insertprofileSuccess(response.data));
  } catch (error) {
    yield put(insertprofileFailure(error.response?.data?.message || error.message));
  }
}

export function* watchinsertprofileSaga() {
  yield takeLatest(insertprofileRequest.type, insertprofileSaga);
}

